WiseMetering.Views.UploadInvoices = WiseMetering.Views.Modal.Custom.extend({
    buttons: ['ok', 'cancel'],
    className: 'mbx-info text-left',
    template: 'templates/invoices/upload',
    title: () => i18next.t('modal.title.invoices.upload'),
    width: 560,

    events: {
        'change #invoice-files': 'onFilesPicked',
        'click #invoice-drop-target': 'openFilePicker',
        'click .drop-zone-file-remove': 'onRemoveFile',
        'dragenter #invoice-drop-target': 'onDragEnter',
        'dragover #invoice-drop-target': 'onDragOver',
        'dragleave #invoice-drop-target': 'onDragLeave',
        'drop #invoice-drop-target': 'onDrop'
    },

    initialize: function(attributes) {
        this.files = [];
        this.dragCounter = 0;
        // Modal.Custom hands our handlers to the modal box unbound, so `this`
        // would be the modal instead of this view when ok is clicked
        this.ok = this.ok.bind(this);
        WiseMetering.Views.Modal.Custom.prototype.initialize.call(this, attributes);
    },

    serializeData: function() {
        return {
            maxFiles: WiseMetering.Views.UploadInvoices.MAX_FILES
        };
    },

    openFilePicker: function() {
        this.$('#invoice-files')[0].click();
    },

    onFilesPicked: function(event) {
        this.addFiles(event.currentTarget.files);
        // Resets the input so removing a file and picking it again still fires change
        this.$('#invoice-files').val('');
    },

    onDragEnter: function(event) {
        event.preventDefault();
        // Counts nested enters/leaves so hovering the inner text doesn't drop the highlight
        this.dragCounter++;
        this.$('#invoice-drop-target').addClass('active');
    },

    onDragOver: function(event) {
        event.preventDefault();
    },

    onDragLeave: function(event) {
        event.preventDefault();
        this.dragCounter--;
        if (this.dragCounter <= 0) {
            this.dragCounter = 0;
            this.$('#invoice-drop-target').removeClass('active');
        }
    },

    onDrop: function(event) {
        event.preventDefault();
        this.dragCounter = 0;
        this.$('#invoice-drop-target').removeClass('active');
        this.addFiles(event.originalEvent.dataTransfer.files);
    },

    onRemoveFile: function(event) {
        event.stopPropagation();
        this.files.splice($(event.currentTarget).data('index'), 1);
        this.renderFiles();
        this.showErrors([]);
    },

    addFiles: function(fileList) {
        const maxFiles = WiseMetering.Views.UploadInvoices.MAX_FILES, errors = [];

        Array.from(fileList).forEach(file => {
            if (file.type !== 'application/pdf') {
                errors.push(i18next.t('invoices.pdf_files_only'));
                return;
            }

            if (this.files.length >= maxFiles) {
                errors.push(i18next.t('invoices.max_files_exceeded', { count: maxFiles }));
                return;
            }

            const alreadyStaged = this.files.some(staged => staged.name === file.name && staged.size === file.size);
            if (!alreadyStaged) {
                this.files.push(file);
            }
        });

        this.renderFiles();
        this.showErrors(_.uniq(errors));
    },

    renderFiles: function() {
        const items = this.files.map((file, index) => `
            <li>
                <span class='drop-zone-file-name' title='${_.escape(file.name)}'>${_.escape(file.name)}</span>
                <span class='drop-zone-file-size'>${this.formatSize(file.size)}</span>
                <i class='fas fa-times drop-zone-file-remove' data-index='${index}' title='${i18next.t('invoices.remove_file')}'></i>
            </li>`);

        this.$('#invoice-file-list').html(items.join(''));
    },

    formatSize: function(bytes) {
        const kilobytes = bytes / 1024;
        return kilobytes < 1024 ? `${Math.round(kilobytes)} KB` : `${(kilobytes / 1024).toFixed(1)} MB`;
    },

    showErrors: function(errors) {
        const $errors = $(this.modal.errors.el);

        if (errors.length === 0) {
            $errors.removeClass('active').empty();
            return;
        }

        $errors.addClass('active').html(errors.join('<br/>'));
    },

    ok: function() {
        if (this.files.length === 0) {
            this.showErrors([i18next.t('invoices.no_files_selected')]);
            return;
        }

        this.showErrors([]);
        this.modal.block();

        WiseMetering.Views.UploadInvoices.upload(this.model.id, this.files).done(response => {
            WiseMetering.layout.showTipper('success', `${i18next.t('invoices.bulk_upload_success', { count: response.invoice_ids.length })} ${i18next.t('invoices.bulk_upload_email_notification_pending')}`);
            WiseMetering.invoices.fetch();
            this.modal.close();
        }).fail(response => {
            this.showErrors([WiseMetering.Views.UploadInvoices.errorMessage(response)]);
            this.modal.unblock();
        });
    }
}, {
    MAX_FILES: 12,

    errorMessage: function(response) {
        return WiseMetering.utils.uploadErrorMessage(response, body => body?.error, i18next.t('invoices.bulk_upload_failed'));
    },

    upload: function(utilityId, files) {
        const formData = new FormData();

        formData.append('utility_id', utilityId);
        Array.from(files).forEach(file => formData.append('files[]', file));

        return new WiseMetering.Model.Invoice().bulkUpload(formData);
    }
});
